/*
    Рандомные изображения в меню, форме
*/

import { FadeInImage } from './FadeInImage';

class RandomImages {
    constructor(container) {
        this.$container = $(container);
        this.category = this.$container.data('image-category');

        if (window.randomImages && window.randomImages[this.category]) {
            this.array = window.randomImages[this.category];
            this.init();
        }
    }

    init() {
        this.$container.removeClass('_loaded');

        // Выбираем случайное изображение и подставляем
        const url = this.array[ Math.floor(Math.random() * this.array.length) ];

        this.$container.css({
            'background-image': `url(${url})`
        });

        // Следим за изображением, чтобы оно плавно появилось после загрузки
        new FadeInImage(this.$container);
    }
}


App.W.on('barba:afterEnter', () => {
    App.H.find('.js-random-image').each(function() {
        new RandomImages(this);
    });
});



// WEBPACK FOOTER //
// ./_src/js/modules/RandomImages.js